import { Storage } from '@/utils';
import store from '@/store';

export default function Session() {
  // 8 hrs = 8 * 60 * 60 * 1000
  // 5 min = 5 * 60 * 1000
  const duration = (7 * 60 * 60 * 1000) + (50 * 60 * 1000);

  function exists() {
    return Storage.get('session');
  }

  function set(user) {
    if (!exists() && window._.get(user, 'user.email')) {
      Storage.set('session', Date.now() + duration);
    }
  }

  function check() {
    if (exists() && Date.now() > Storage.get('session')) {
      Storage.rm('session');
      store.commit('LOGOUT');
      const url = window.location.origin;
      window.location.href = `${url}/api/auth/initiatesinglelogout?returnUrl=${url}/logout`;
    }
  }

  return {
    set,
    check,
  };
}
